import React from 'react';

import Accordion from '../../Accordion';

import AccordionContent, { type Props as AccordionContentProps } from './_AccordionContent';

/**
 * Types
 */

export interface Props extends AccordionContentProps {}

/**
 * Component
 */

export default function FAQAccordion({ index, question, answer, openedIndex, setOpenedIndex }: Props) {
  return (
    <li className="border-neutrals-100 mb-6 border-b">
      <Accordion defaultOpen={index === 0}>
        <AccordionContent
          index={index}
          question={question}
          answer={answer}
          openedIndex={openedIndex}
          setOpenedIndex={setOpenedIndex}
        />
      </Accordion>
    </li>
  );
}
